const base_path = "/new_images/ceramic_coating/7__Toyota_Fortuner/";

const file_names: string[] = [
    "1", // preview
    "2",
    "3",
    "4",
]

const file_names_sizes: {[key: string]: {w: number, h: number}} = {
    "1": {w: 1080, h: 810},
    "2": {w: 810, h: 1080},
    "3": {w: 810, h: 1080},
    "4": {w: 810, h: 1080},
}

export const Toyota_Fortuner = file_names.map((f) => {
    const size = file_names_sizes[f];

    return {
        jpg: base_path+f+".jpeg",
        webp: base_path+f+".webp",
        alt: "Toyota Fortuner",
        w: size.w.toString(),
        h: size.h.toString(),
    }
});